import { z } from "zod";

export enum ReportDownloadTypeEnum {
    DATA = 0,
    EXCEL_FILE = 1,
    CSV_FILE = 2,
}

export const ReportDownloadTypeEnumSchema = z.nativeEnum(ReportDownloadTypeEnum);
export type ReportDownloadTypeEnumSchema = z.infer<typeof ReportDownloadTypeEnumSchema>;